<div class="shift-breadcrumb-info">
  <div class="shift-breadcrumb-info-row">
    <span class="shift-breadcrumb-label">Time:</span>
    <span>{{ vehicleMarkerFeature.properties.unixtime * 1000 | date:'hh:mm:ss' }}</span>
  </div>
  <div class="shift-breadcrumb-info-row">
    <span class="shift-breadcrumb-label">Speed:</span>
    <span>{{ vehicleMarkerFeature.properties.speed | speed:configuration.useMetricSystem }}</span>
  </div>
  <div class="shift-breadcrumb-info-row">
    <span class="shift-breadcrumb-label">Heading:</span>
    <span>{{ vehicleMarkerFeature.properties.heading | compass }}</span>
  </div>
  <div class="shift-breadcrumb-info-row">
    <span class="shift-breadcrumb-label">Location:</span>
    <span>{{ vehicleMarkerFeature.geometry.coordinates | latLng }}</span>
  </div>
  <div class="shift-breadcrumb-info-row">
    <span class="shift-breadcrumb-label">GPS Source:</span>
    <span>{{ vehicleMarkerFeature.properties.gpssource | gpsSource }}</span>
  </div>

  @if(shift.vehicleHardwareConfiguration &&
  shift.vehicleHardwareConfiguration.sensorInputs &&
  shift.vehicleHardwareConfiguration.sensorInputs.length > 0
    ) {
    @for (sensorInput of HardwareConfiguration.getValidInputs(shift.vehicleHardwareConfiguration.sensorInputs); track sensorInput) {
      @if (sensorInput.type === SensorType.PLOW || sensorInput.type === SensorType.PLOW2W) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Plow' }}:</span>
          <span>{{ sensorInput.bitNumber | plowStatus: vehicleMarkerFeature.properties.flags }}</span>
        </div>
      } @else if (sensorInput.type === SensorType.GRANULAR_SPREADER) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Granular Spreader' }}:</span>
          <span>{{ sensorInput.bitNumber | spreaderStatus: vehicleMarkerFeature.properties.flags }}
            ({{ sensorInput.rate || 'N/A' }} {{'granular' | rateUnit:configuration.useMetricSystem}})</span>
        </div>
      } @else if (sensorInput.type === SensorType.DIGITAL_GRANULAR_SPREADER) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Digital Granular Spreader' }}:</span>
          <span>{{ sensorInput.bitNumber | spreaderStatus: vehicleMarkerFeature.properties.flags }}
            ({{ (digitalGranularStatus?.controllerCurrentRate | spreaderMass:configuration.useMetricSystem) || 'N/A' }})</span>
        </div>
      } @else if (sensorInput.type === SensorType.LIQUID_SPREADER) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Liquid Spreader' }}</span>
          <div>
            {{ sensorInput.bitNumber | spreaderStatus: vehicleMarkerFeature.properties.flags }}
            ({{ sensorInput.rate || 'N/A' }} {{'liquid' | rateUnit:configuration.useMetricSystem }})
          </div>
        </div>
      } @else if (sensorInput.type === SensorType.DIGITAL_LIQUID_SPREADER) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Digital Liquid Spreader' }}:</span>
          <span>{{ sensorInput.bitNumber | spreaderStatus: vehicleMarkerFeature.properties.flags }}
            ({{ (digitalLiquidStatus?.controllerCurrentRate | spreaderLiquid:configuration.useMetricSystem) || 'N/A' }})</span>
        </div>
      } @else if (sensorInput.type === SensorType.MOWER) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Mower' }}:</span>
          <span>{{ sensorInput.bitNumber | mowerStatus: vehicleMarkerFeature.properties.flags }}</span>
        </div>
      } @else if (sensorInput.type === SensorType.SWEEPER) {
        <div class="shift-breadcrumb-info-row">
          <span class="shift-breadcrumb-label">{{ !!sensorInput.label ? sensorInput.label : 'Sweeper' }}:</span>
          <span>{{ sensorInput.bitNumber | sweeperStatus: vehicleMarkerFeature.properties.flags }}</span>
        </div>
      }
    }
  }
</div>
